import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import SelectAjax from "../../components/form/SelectAjax";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import Component from "./Component";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import {FormDataToJson} from '../../utils/json/Json';
import PAGES from '../../config/Pages';

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.state = {
      wrapper:Random(7),
      strings:STRINGS[window.LANGUAGE],
      boxes:props.detalhe ? this.getBoxes(props.detalhe) : this.getBoxes([])
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  getBoxes (__args__){
    let qdias = __args__.qtde_dias;
    return <Component
            ativarBox=" ativo "
            key={Random(7)}
            dados={__args__}
            qntDias={qdias}>
          </Component>;
  }

  handleSelectChange(__args__){
    let id = __args__.value;
    var _self = this;

    Requisitions({
			url:WS.blocos_planilha.detalhe,
			data:{id:id},
			sucess:function(data){
        _self.setState((prevState, props) => ({
          boxes: _self.getBoxes(data.item)
        }));
			},
			error:function(data){

			}
		});
  }

  checkForm (e){
    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar,
      escolhaQntDias,
      adicioneBlocos,
      qntBlocosMenorQueQntDias,
      erroBlocoPlanilha
    }
    = this.state.strings;

    const formData = new FormData(e.target);

    //retorna todos os exercicios adicionados
    const idForm = e.target.getAttribute('id');
    const form = document.getElementById(idForm);
    const elements = form.querySelectorAll('.item-listagem');
    var exercicios = [];

    //transforma o formData em um json
    var object = FormDataToJson(formData);

    //checa se existe o nome da planilha
    if(!object.nome_bloco_planilha){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);
      return false;
    }

    //----------------
    //aqui iniciamos a formatação do json para envio ao DB
    let boxComponent = form.getElementsByClassName('wrapper-bloco-planilha');

    if(!boxComponent[0]){
      let msg = {
        title: atencao,
        text: erroBlocoPlanilha
      };
      Dialog.create(msg);
      return false;
    }

    let box = boxComponent[0];
    let qntDias = box.querySelectorAll("[name='quantidade_dias']")[0].value;

    //checa se o usuário escolheu a quantidade de dias da planilha
    if(!qntDias){
      let msg = {
        title: atencao,
        text: escolhaQntDias
      };
      Dialog.create(msg);
      return false;
    }

    //blocos
    const classBlocoPlanilha = 'bloco-planilha-wrapper';
    let blocoPlanilhaWrapper = form.getElementsByClassName(classBlocoPlanilha);

    //checa se existem exercícios adicionados a planilha
    if(!blocoPlanilhaWrapper[0]){
      let msg = {
        title: atencao,
        text: adicioneBlocos
      };
      Dialog.create(msg);
      return false;
    }

    const blocosLength = blocoPlanilhaWrapper.length;

    if(blocosLength < qntDias){
      let msg = {
        title: atencao,
        text: qntBlocosMenorQueQntDias
      };
      Dialog.create(msg);
      return false;
    }

    //damos um for no array de blocoPlanilhaWrapper para
    //criarmos o json contendo os itens da planilha

    var dadosForm = {};
    dadosForm.nome = object.nome_bloco_planilha;
    dadosForm.observacoes = object.observacoes_bloco_planilha;
    dadosForm.qtde_dias = qntDias;
    dadosForm.blocos = [];

    for(var i=0; i < blocoPlanilhaWrapper.length; i++) {
      const item = blocoPlanilhaWrapper[i];
      const cadencia = item.querySelectorAll("[name='cadencia']")[0] ? item.querySelectorAll("[name='cadencia']")[0].value : '';
      const repeticoes = item.querySelectorAll("[name='repeticoes']")[0] ? item.querySelectorAll("[name='repeticoes']")[0].value : '';
      const intervalo = item.querySelectorAll("[name='intervalo']")[0] ? item.querySelectorAll("[name='intervalo']")[0].value : '';
      const dias_semana = item.querySelectorAll("[name='dias_semana']")[0].value;
      const observacoesBloco = item.querySelectorAll("[name='observacoes']")[0].value;
      const local_treino = item.querySelectorAll(`[name='local_treino']`)[0].value;

      const circuito = item.querySelectorAll("[name='circuito']")[0] ? item.querySelectorAll("[name='circuito']")[0].value : '';
      const sessoes = item.querySelectorAll("[name='sessoes']")[0] ? item.querySelectorAll("[name='sessoes']")[0].value : '';

      //exercícios
      const classExercicios = 'item-listagem';
      let blocosExercicios = item.getElementsByClassName(classExercicios);
      var exercicios = [];

      //adicionamos no array de exercícios todos os exercícios do bloco
      for(var j=0; j < blocosExercicios.length; j++) {
        const exercicio = blocosExercicios[j];
        const id = exercicio.getAttribute('data-id');
        if(id){
          exercicios.push(id);
        }

      }

      const dados = {
        cadencia,
        repeticoes,
        intervalo,
        dias_semana,
        circuito,
        sessoes,
        local_treino,
        observacoes: observacoesBloco,
        exercicios
      };

      dadosForm.blocos.push(dados);
    }

    return dadosForm;
  }

  handleSubmit (e){
    e.preventDefault();
    const formData = new FormData(e.target);
    const dadosForm = this.checkForm(e);

    if(!dadosForm){
      return false;
    }
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar,
      escolhaQntDias,
      adicioneBlocos,
      qntBlocosMenorQueQntDias,
      erroBlocoPlanilha,
      errorSaveBlocoPlanilha
    }
    = this.state.strings;

    //-----------------------
    //-----------------------
    //remove o modal

    var msg;
    var self = this;

    //caso haja o id_bloco_planilha adicionamos ele no formulário para editar o item
    if(formData.get('id_bloco_planilha')){
      dadosForm.id = formData.get('id_bloco_planilha');
    }

    const history = this.props.history;

    Requisitions({
			url:WS.blocos_planilha.save,
			data: dadosForm,
			sucess:function(data){
        self.props.modal.close();
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
        history.push(PAGES.blocosPlanilha);

      },
      error:function(data){console.log(data);
        msg = {
          title: atencao,
          text: errorSaveBlocoPlanilha
        };
        Dialog.create(msg);
      }
		});

    //----------------
    //----------------
  }

  render (){
    const {
      titleBlocosPlanilha,
      nomeBloco,
      digiteAqui,
      copiarBlocoPlanilha,
      observacoes,
      salvar
    } = this.state.strings;

    const nomeVal = this.props.detalhe ? this.props.detalhe.nome : '';
    const obsVal = this.props.detalhe ? this.props.detalhe.observacoes : '';
    const id = this.props.detalhe ? <input type='hidden' name='id_bloco_planilha' value={this.props.detalhe.id} />   : '';

    return (
      <div className='box-planilha-bloco'>
        <MainTitle title={titleBlocosPlanilha}></MainTitle>
        <form id={this.state.wrapper} onSubmit={this.handleSubmit}>
          {id}
          <div className="pure-u-15-24">
            <TextInput name="nome_bloco_planilha" title={nomeBloco+"*"} value={nomeVal} placeholder={digiteAqui}></TextInput>
          </div>
          <div></div>
          <div className="pure-u-15-24">
            <SelectAjax onChange={this.handleSelectChange} url={WS.blocos_planilha.search} title={copiarBlocoPlanilha} />
          </div>
          <div className="">
            <TextArea name="observacoes_bloco_planilha" title={observacoes} value={obsVal} placeholder=""></TextArea>
          </div>
          <br/><br/>
          <div className="js-box-component" >
            {this.state.boxes}
          </div>
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/blocos-planilha/Page.js